import { Table, TableContainer, Typography, Paper, TableBody, TableRow, TableCell,  Grid } from '@material-ui/core';
import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/styles';
import React, { ReactNode, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AddMoney } from '../dashboardAction';
import BackgroundTheme from '../../../../Common/P2P/Header/BackgroundTheme';
import RoundButton from '../../../../Common/RoundButton';
import { useHistory } from 'react-router-dom';
import { logFirebaseEvent } from '../../firebase';
import { P2P_PAYMENT_MODE_VIEW } from '../../firebase/constant';

const useStyles = makeStyles(() => ({
    container: {
        background: '#F8F8F8',
    }
}));

const textStyle = {
    fontSize: '14px',
    fontFamily: 'Montserrat',
    margin: '10px auto'
}

const noteTextStyle = {
    fontSize: '14px',
    fontFamily: 'Montserrat',
    color: '#D8A379',
    margin: '10px auto'
}

const BankDetails = () => {
    const history = useHistory();
    const classes = useStyles();
    let dispatch = useDispatch();

    useEffect(() => {
        logFirebaseEvent(P2P_PAYMENT_MODE_VIEW);
        dispatch(AddMoney())
        document.title = "stashearn - bank-detail"
    }, []);
    const backToDashboard = () => {
        history.push({
            pathname: '/p2p/dashboard'
        })
    }
    return (
        <>
            <BackgroundTheme>
                <Grid container >
                    <Paper elevation={0} className={classes.container}>
                        <Paper style={{ padding: 10 }}>
                            <Typography variant="h5" align="center" style={{ color: '#ff0028' }}> Bank account for funds transfer </Typography>
                            <Typography component="p" style={textStyle}>Register the following bank account as beneficiary in your account and transfer through NEFT/IMPS.RTGS</Typography>
                            <TableContainer style={{ fontSize: '12px', border: '1px solid #93C4E1', borderRadius: '5px' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="left" variant="head" style={{ width: "30%", padding: '5px', fontSize: '12px', backgroundColor: "#EAF5FB", color: '#93C4E1', borderRight: '1px solid' }} className="table-header">Account Number</TableCell>
                                            <TableCell align="right" style={{ width: "70%", padding: '5px', fontSize: '12px', borderBottom: '1px solid' }} className="table-body">0004102000039880</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left" variant="head" style={{ width: "30%", padding: '5px', fontSize: '12px', backgroundColor: "#EAF5FB", color: '#93C4E1', borderRight: '1px solid' }} className="table-header">IFSC Code</TableCell>
                                            <TableCell align="right" style={{ width: "70%", padding: '5px', fontSize: '12px', borderBottom: '1px solid' }} className="table-body">IBKL0000004</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left" variant="head" style={{ width: "30%", padding: '5px', fontSize: '12px', backgroundColor: "#EAF5FB", color: '#93C4E1', borderRight: '1px solid' }} className="table-header">Beneficiary name</TableCell>
                                            <TableCell align="right" style={{ width: "70%", padding: '5px', fontSize: '12px', borderBottom: '1px solid' }} className="table-body">NDX P2P Pvt Ltd Lenders Funding Account</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left" variant="head" style={{ width: "30%", padding: '5px', fontSize: '12px', backgroundColor: "#EAF5FB", color: '#93C4E1', borderRight: '1px solid' }} className="table-header">Bank Name</TableCell>
                                            <TableCell align="right" style={{ width: "70%", padding: '5px', fontSize: '12px', borderBottom: '1px solid' }} className="table-body">IDBI Bank</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box>
                                <Typography component="p" style={textStyle}>Once you transfer the funds to the above mentioned bank account, it may take up to 24 hours to reflect in your portfolio.
                                </Typography>
                                <Typography component="p" style={noteTextStyle}>Note : Investment should be transferred from the bank account shared during your on-boarding journey as a Stashearn customer
                                </Typography>
                            </Box>
                            <RoundButton title="dashboard" onClick={backToDashboard} />
                        </Paper>
                    </Paper>
                </Grid>
            </BackgroundTheme>
        </>
    )
}

export default BankDetails;